import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import "./CustomerRefundPrint.css";
import { Button } from "antd";
import CustomerRefundPrintHeader from "./CustomerRefundPrintHeader/CustomerRefundPrintHeader";
import { TabTitle } from "../../utils/GeneralFunction";
import moment from "moment";
import numeral from "numeral";
import { getOneCustomerRefundLine } from "../../redux/actions/customerRefundLine.action";
import { getCustomerRefundPrint } from "../../redux/actions/customerRefundPrint.action";
import Loader from "react-loader-spinner";
import { currencySymbol } from "../../utils/constants";

const CustomerRefundPrint = ({ token }) => {
  TabTitle("Customer Refund Reports")
  const dispatch = useDispatch();
  const { customerRefundPrint } = useSelector((state) => state);
  const [data, setData] = useState([]);

  function useQuery() {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
  }

  let query = useQuery();
  let refund_header_id = query.get("refund_header_id");

  const values = {
    refund_header_id: refund_header_id,
  };

  useEffect(() => {
    dispatch(getCustomerRefundPrint(token, values));
    dispatch(getOneCustomerRefundLine(token, refund_header_id)).then((res) => {
      if (res.type === "GET_ONE_CUSTOMER_REFUND_LINE_SUCCESS") {
        setData(res.payload.data);
      }
    });
  }, [refund_header_id]);

  const handlePrint = () => {
    const css = '@page { size: landscape; }';
    const style = document.createElement('style');
    style.innerHTML = css;
    document.head.appendChild(style);
    window.print();
    document.head.removeChild(style); // Clean up after print
  };

  if (customerRefundPrint?.loading) {
    return <>
      <div className='loaderDiv' >
        <Loader
          type="Grid"
          color="#212121"
          height={40}
          width={40}
        />
      </div>
    </>
  }

  const totalAppliedAmount = data
    ?.reduce((sum, item) => sum + (Number(item.applied_amount) || 0), 0);

  return (
    <div className="__customer_refund_report">
      <table width="100%">
        <thead>
          <tr>
            <td>
              <CustomerRefundPrintHeader />
            </td>
          </tr>
        </thead>
        <tbody>
          <tr className="no-print">
            <td>
              <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '16px' }}>
                <Button type="primary" onClick={handlePrint}>
                  Print
                </Button>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <Body myData={data} amount={totalAppliedAmount} />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

const Body = ({ myData, amount }) => {
  return (
    <>
      <div className="__content">
        <div className="__list_items">
          <table width="100%">
            <thead>
              <tr>
                <th
                  style={{
                    width: "36px",
                  }}
                >
                  S.No
                </th>
                <th
                  style={{
                    width: "88px",
                  }}
                >
                  Transaction Type
                </th>
                <th
                  style={{
                    width: "80px",
                    whiteSpace: 'nowrap',
                  }}
                >
                  Transaction No #
                </th>
                <th
                  style={{
                    width: "70px",
                    whiteSpace: 'nowrap',
                  }}
                >
                  Transaction Date
                </th>
                <th
                  style={{
                    width: "90px",
                  }}
                >
                  RA #
                </th>
                <th
                  style={{
                    width: "90px",
                  }}
                >
                  Invoice #
                </th>
                <th
                  style={{
                    width: "90px",
                  }}
                >
                  Receipt #
                </th>
                <th
                  style={{
                    width: "90px",
                  }}
                >
                  Gender Name
                </th>
                <th
                  style={{
                    width: "90px",
                  }}
                >
                  Term Name
                </th>
                <th
                  style={{
                    width: "90px",
                  }}
                >
                  Amount
                </th>
              </tr>
            </thead>
            <tbody>
              {
                myData?.map((it, index) => {
                  return (
                    <tr key={index}>
                      <td
                        style={{
                          marginLeft: "0",
                        }}
                      >
                        {index}
                      </td>
                      <td>
                        {it?.transaction_type}
                      </td>
                      <td
                        style={{
                          textAlign: "right",
                          paddingRight: 5
                        }}
                      >
                        {it?.note_header_no}
                      </td>
                      <td>
                        {moment(it?.note_date).format("MM-DD-YYYY")}
                      </td>
                      <td
                        style={{
                          textAlign: "right",
                          paddingRight: 5
                        }}
                      >
                        {it?.ra_no}
                      </td>
                      <td
                        style={{
                          textAlign: "right",
                          paddingRight: 5
                        }}
                      >
                        {it?.invoice_header_no}
                      </td>
                      <td
                        style={{
                          textAlign: "right",
                          paddingRight: 5
                        }}
                      >
                        {it?.receipt_header_no}
                      </td>
                      <td>
                        {it?.gender_name}
                      </td>
                      <td>
                        {it?.term_name}
                      </td>
                      <td
                        style={{
                          textAlign: "right",
                          whiteSpace: 'nowrap',
                          paddingRight: 5
                        }}
                      >
                        {currencySymbol} {numeral(it?.applied_amount).format("00.00")}
                      </td>
                    </tr>
                  )
                })
              }
              <tr>
                <td style={{ height: "15px", border: 0 }}></td>
              </tr>
              <tr>
                <td colSpan={8} style={{ border: 0 }}></td>
                <td><p>Refund Amount</p></td>
                <td style={{ textAlign: "end" }}>{currencySymbol} {numeral(amount).format("00.00")}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </>
  )
}

export default CustomerRefundPrint;